import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { isRtlLanguage } from '../../constants/uiLanguages'

/**
 * Keeps <html lang dir> in sync with i18n (RTL for fa/ar, full-page bidi + logical Tailwind).
 */
export default function I18nDocumentLang() {
  const { i18n } = useTranslation()

  useEffect(() => {
    const short = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0].toLowerCase()
    document.documentElement.lang = short
    document.documentElement.dir = isRtlLanguage(short) ? 'rtl' : 'ltr'
  }, [i18n.language, i18n.resolvedLanguage])

  return null
}
